import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';


const REST_SERVICE_URL = 'http://www.airovtech.com';
// const REST_SERVICE_URL = 'http://localhost:8060'    // 개발용

const LOGIN_URL = REST_SERVICE_URL + '/login';


@Injectable({
  providedIn: 'root'
})
export class ApiService {

  constructor(
    public http: HttpClient
  ) { }

  public callApi(url:string, method:string, params:any, data:any): Observable<any> {

    const headers = new HttpHeaders().set('Content-Type', 'application/json; charset=utf-8');

    if(method ==='get'){
      return this.http.get(url,{headers});
    }
    else{
      return this.http.post(url,JSON.stringify(data),{headers});
    }
  }
  createNoticeData(data:any){
    return new Promise((resolve, reject) => {
      this.callApi(REST_SERVICE_URL +'/createNoticeData', 'post', null, data).subscribe( (val) => { resolve(val); }, (err) => {reject(err);});
    }); 
  }
  createRecruitData(data:any){
    return new Promise((resolve, reject) => {
      this.callApi(REST_SERVICE_URL +'/createRecruitData', 'post', null, data).subscribe( (val) => {  resolve(val);}, (err) => {reject(err);});
    }); 
  }
  getNoticeData(){
    return new Promise((resolve, reject) => {
      this.callApi(REST_SERVICE_URL +'/getNoticeData' , 'get', null, null).subscribe( (val) => {  resolve(val.result); }, (err) => {reject(err);});
    }); 
  }
  getRecruitData(){
    return new Promise((resolve, reject) => {
      this.callApi(REST_SERVICE_URL +'/getRecruitData' , 'get', null, null).subscribe( (val) => {  resolve(val.result); }, (err) => {reject(err);});
    }); 
  }
  getAllData(){
    return new Promise((resolve, reject) => {
      this.callApi(REST_SERVICE_URL +'/getAllData', 'get', null, null).subscribe((val) => { resolve(val.result);}, (err) => {reject(err);});
    }); 
  }
  setNoticeData(data:any){
    return new Promise((resolve, reject) => {
      this.callApi(REST_SERVICE_URL +'/setNoticeData', 'post', null, data).subscribe( (val) => {  resolve(val); }, (err) => {reject(err);});
    }); 
  }
  setRecruitData(data:any){
    return new Promise((resolve, reject) => {
      this.callApi(REST_SERVICE_URL +'/setRecruitData', 'post', null, data).subscribe( (val) => {  resolve(val);}, (err) => {reject(err);});
    }); 
  }
  removeNoticeData(ids:Array<string>){
    return new Promise((resolve, reject) => {
      this.callApi(REST_SERVICE_URL +'/removeNoticeData', 'post', null, {ids:ids}).subscribe( (val) => {  resolve(val); }, (err) => {reject(err);});
    }); 
  }
  removeRecruitData(ids:Array<string>){
    return new Promise((resolve, reject) => {
      this.callApi(REST_SERVICE_URL +'/removeRecruitData', 'post', null, {ids:ids}).subscribe( (val) => {  resolve(val); }, (err) => {reject(err);});
    }); 
  }
  login(id:string, pw:string) {
    return new Promise((resolve, reject) => {
        this.callApi(LOGIN_URL, 'post', null, {username: id, password: pw}).subscribe( (val) => {  resolve(val); }, response => { console.log("POST call in error", response); }, () => { console.log("The POST observable is now completed."); })
    });
}
}
